var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"pc-more",attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('span',[_vm._v(_vm._s(_vm.text))]),_c('img',{attrs:{"src":require("../assets/pc/箭头@2x.png"),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }